// extracted by mini-css-extract-plugin
export var footer = "footer-module--footer--02543";
export var fourColumns = "footer-module--four-columns--16e4b";
export var twoColumns = "footer-module--two-columns--75e02";